import { render, staticRenderFns } from "./AdminMailingsForm.vue?vue&type=template&id=ea49b3dc&scoped=true"
import script from "./AdminMailingsForm.vue?vue&type=script&lang=js"
export * from "./AdminMailingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea49b3dc",
  null
  
)

export default component.exports